import { render, staticRenderFns } from "./BuyerAccountApproval.vue?vue&type=template&id=07ed143b&scoped=true"
import script from "./BuyerAccountApproval.vue?vue&type=script&lang=js"
export * from "./BuyerAccountApproval.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountApproval.vue?vue&type=style&index=0&id=07ed143b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed143b",
  null
  
)

export default component.exports